import {DEFAULT_COLUMN_WIDTH} from 'notebook/structured-tables/StructuredTableConstants';

const MAX_WORKFLOW_TASK_SCHEMA_NAME_LENGTH = 140; // Current max in the DB is 150, allow 10 characters of buffer room for uniqueness
export const MAX_PROCEDURE_NAME_LENGTH = MAX_WORKFLOW_TASK_SCHEMA_NAME_LENGTH;
export const MAX_PROCEDURE_RUN_DESCRIPTION_LENGTH = 255;
const MAX_PLAN_METHOD_SUFFIX_LENGTH = 30; // Method name is suffixed with " - Condition [1, 48] - Replicate [1, 10]" during procudure plan
const MAX_METHOD_NAME_LENGTH_BACKEND = MAX_WORKFLOW_TASK_SCHEMA_NAME_LENGTH;
export const MAX_METHOD_NAME_LENGTH = MAX_METHOD_NAME_LENGTH_BACKEND - MAX_PLAN_METHOD_SUFFIX_LENGTH;
export const MAX_STEP_NAME_LENGTH = MAX_WORKFLOW_TASK_SCHEMA_NAME_LENGTH;
const MAX_MATERIAL_NAME_LENGTH = 58;
const MAX_SCHEMA_FIELD_SUFFIX_LENGTH = 14;
// Keep in sync with PARAMETER_NAME_MAX_LENGTH in benchling/procedures/parameter_library/constants/validation_constants.py
export const MAX_PARAMETER_NAME_LENGTH = MAX_MATERIAL_NAME_LENGTH - MAX_SCHEMA_FIELD_SUFFIX_LENGTH;
// Keep in sync with PARAMETER_DESCRIPTION_MAX_LENGTH in benchling/procedures/parameter_library/constants/validation_constants.py
export const MAX_PARAMETER_DESCRIPTION_LENGTH = 2048;

/**
 * Product limits for procedure models. These values should always be kept in sync with ProcedureProductLimits
 * in benchling/procedures/constants/product_limits.py
 */
export const PROCEDURE_PRODUCT_LIMITS = {
  METHODS_PER_PROCEDURE: 20,
  STEPS_PER_METHOD: 50,
  MATERIAL_INPUTS_PER_METHOD: 100,
  MATERIAL_OUTPUTS_PER_METHOD: 50,
  EQUIPMENT_PER_METHOD: 100,
  DATA_PARAMETERS_PER_METHOD: 200,
  PARAMETERS_PER_PROCEDURE: 2000,
  MAX_PARAMETER_VALUES: 384,
  TEST_DEFINITIONS_PER_PROCEDURE: 100,
};

export const PARAMETER_TABLES_COLUMN_WIDTHS = {
  NARROW: DEFAULT_COLUMN_WIDTH,
  NORMAL: DEFAULT_COLUMN_WIDTH + 40,
  WIDE: DEFAULT_COLUMN_WIDTH + 80,
};
